import { useQuery } from '@tanstack/react-query';
import { validatedApi } from '../../../lib/api/validated-client';

interface PlatformStats {
  totalVenues: number;
  totalCities: number;
  totalBookings: number;
  venueTypeCounts?: {
    GAMING: number;
    SNOOKER: number;
    KIDS_PLAYAREA: number;
  };
}

/**
 * Hook to fetch platform statistics from the real API.
 */
export function usePlatformStats() {
  return useQuery<PlatformStats>({
    queryKey: ['platform', 'stats'],
    queryFn: () => validatedApi.get<PlatformStats>('/stats/platform'),
    staleTime: 1000 * 60 * 10, // 10 minutes (stats change slowly)
  });
}
